<template>
  <div class="form-group">
    <div
      :class="[
       {'input-group': hasIcon},
       {'has-danger': error},
       {'focused': focused},
       {'input-group-alternative': alternative},
       {'has-label': label || $slots.label},
       {'has-success': valid === true},
       {'has-danger': valid === false}
       ]"
    >
      <slot name="label">
        <label v-if="label" :class="labelClasses">
          {{label}}
          <span v-if="required">*</span>
        </label>
      </slot>

      <div v-if="addonLeftIcon || $slots.addonLeft" class="input-group-prepend">
        <span class="input-group-text">
          <slot name="addonLeft">
            <i :class="addonLeftIcon"></i>
          </slot>
        </span>
      </div>
      <slot v-bind="slotData">
        <input
          :value="value"
          v-on="listeners"
          v-bind="$attrs"
          class="form-control"
          :class="[{'is-valid': valid === true}, {'is-invalid': valid === false}, inputClasses]"
          aria-describedby="addon-right addon-left"
          @input="onInput($event.target.value)"
          @blur="isOpened = false"
          @keyup.enter="select"
          @keyup.tab="select"
          @keydown.down="onDown"
          @keydown.up="onUp"
          @keyup.esc="isOpen = false"
          ref="dropdown"
          v-model="search"
        />
      </slot>
      <div v-if="addonRightIcon || $slots.addonRight" class="input-group-append"  @click="toggle">
        <span class="input-group-text">
          <slot name="addonRight">
            <i :class="addonRightIcon"></i>
          </slot>
        </span>
      </div>
      <slot name="infoBlock"></slot>
      <slot name="helpBlock">
        <div
          class="text-danger invalid-feedback"
          style="display: block;"
          :class="{'mt-2': hasIcon}"
          v-if="error"
        >{{ error }}</div>
      </slot>
    </div>
    <slot name="dropdown">
      <div class="dropdown-container">
        <transition name="fade" mode="in-out">
          <ul class="options-list" v-show="isOpened">
            <li
              v-for="(option, i) in filteredItems"
              :key="i"
              @mouseenter="selected = i"
              @mousedown="select"
              :class="{'selected': i === selected}"
            >
              {{ option.name }}
              <slot name="item" :title="option.name" :thumbnail="option.thumbnail"></slot>
            </li>
          </ul>
        </transition>
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isOpened: false,
      selected: null,
      search: "",
      // VUE Agron variable
      focused: false
    };
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    // VUe Agron params
    required: {
      type: Boolean,
      description: "Whether input is required (adds an asterix *)"
    },
    valid: {
      type: Boolean,
      description: "Whether is valid",
      default: undefined
    },
    alternative: {
      type: Boolean,
      description: "Whether input is of alternative layout"
    },
    label: {
      type: String,
      description: "Input label (text before input)"
    },
    error: {
      type: String,
      description: "Input error (below input)"
    },
    labelClasses: {
      type: String,
      description: "Input label css classes"
    },
    inputClasses: {
      type: String,
      description: "Input css classes"
    },
    value: {
      type: [String, Number],
      description: "Input value"
    },
    addonRightIcon: {
      type: String,
      description: "Addon right icon"
    },
    addonLeftIcon: {
      type: String,
      description: "Addont left icon"
    }
  },
  methods: {
    onInput(value) {
      this.isOpened = !!value; //(value != '');
      this.selected = null;
    },
    select() {
      const selectedOption = this.filteredItems[this.selected];
      this.$emit("select-item", selectedOption);
      this.search = selectedOption.name;
      this.isOpened = false;
    },
    onDown() {
      if (!this.isOpened) {
        return;
      }
      this.selected = (this.selected + 1) % this.filteredItems.length;
    },
    onUp() {
      if (!this.isOpened) {
        return;
      }

      this.selected =
        this.selected - 1 < 0
          ? this.filteredItems.length - 1
          : this.selected - 1;
    },
    toggle() {
      this.isOpened = !this.isOpened;
      if (this.isOpened) {
        //this.$refs.dropdown.focus();
      }
    },
    // vue agron methods
    updateValue(evt) {
      let value = evt.target.value;
      this.$emit("input", value);
    },
    onFocus(value) {
      this.focused = true;
      this.$emit("focus", value);
    },
    onBlur(value) {
      this.focused = false;
      this.$emit("blur", value);
    }
  },
  computed: {
    filteredItems() {
      const condition = new RegExp(this.search, "i");
      return this.options.filter(item => item.name.match(condition));
    },
    //VUE Agron Functions
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur
      };
    },
    slotData() {
      return {
        focused: this.focused,
        ...this.listeners
      };
    },
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return (
        addonRight !== undefined ||
        addonLeft !== undefined ||
        this.addonRightIcon !== undefined ||
        this.addonLeftIcon !== undefined
      );
    }
  }
};
</script>
<style>
.autocomplete {
  width: 300px;
}
ul.options-list li.selected {
  background-color: #2196f3;
  color: #fff;
}
.dropdown-container {
  position: absolute;
  width: max-content;
  min-width: 95%;
  z-index: 1;
}
input.input-dropdown {
  font-family: "Nunito", Helvetica, Arial, sans-serif;
  height: 40px;
  width: 100%;
  border: 1px solid #2196f3;
  border-radius: 2px 0 0 2px;
  background-color: #2196f3;
  color: #fff;
  font-size: 16px;
  padding-right: 38px;
  padding-left: 8px;
}

input.input-dropdown::-webkit-input-placeholder {
  color: #fff;
}
p.control {
  position: relative;
  display: flex;
  margin-bottom: 0.1rem;
  box-shadow: 0px 1px 5px 1px rgba(119, 119, 119, 0.53);
  z-index: 10;
}

p.control i {
  width: 70px;
  top: 0;
  border: none;
  right: 0;
  color: #fff;
  background: #2196f3;
  box-shadow: -2px 0px 1px #1b7bc7;
  border-radius: 0 2px 2px 0;
}

ul.options-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  border: 1px solid #dbdbdb;
  border-radius: 0 0 3px 3px;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0px 3px 6px 0px rgba(195, 195, 195, 0.76);
}

ul.options-list li {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: flex-end;
  padding: 0.4rem;
  border-bottom: 1px solid #eee;
  color: #666;
  background-color: #fff;
  cursor: pointer;
  transition: 0.3s all ease;
}
.icon-right i {
  transition: 0.3s all ease;
}
.icon-right i:hover,
i.chevron.bottom.chevron-active {
  box-shadow: 0 0 6px #1b7bc7;
  background-color: #38a2f7;
}

ul.options-list li span {
  margin-right: 4px;
}

.chevron:before {
  border-style: solid;
  border-width: 0.25em 0.25em 0 0;
  content: "";
  display: inline-block;
  height: 0.45em;
  left: 0.05em;
  position: relative;
  top: 0.15em;
  transform: rotate(-45deg);
  vertical-align: top;
  width: 0.45em;
  transition: 0.3s all ease;
  will-change: transform;
}

.chevron.bottom:before {
  top: 16px;
  left: 19px;
}

.chevron-active.bottom:before {
  transform: rotate(135deg);
  will-change: transform;
}

.chevron-inactive.bottom:before {
  transform: rotate(225deg);
  will-change: transform;
}

ul.options-list li:last-child {
  border-bottom: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
  will-change: opacity;
  transform: translateY(-30px);
}
</style>
